export default __webpack_public_path__ + "static/media/Wang.0b28fcec.png";